import { render } from "./KRNameActivity.vue?vue&type=template&id=6d4fe0c0"
import script from "./KRNameActivity.vue?vue&type=script&lang=js"
export * from "./KRNameActivity.vue?vue&type=script&lang=js"
script.render = render

export default script